module.exports = __webpack_public_path__ + "img/12.7ea528f2.png";